import React from 'react';

import EventConfigurationLayout from '@totem/components/settings/sections/nozomi/eventConfiguration/EventConfigurationLayout';
import NozomiEventConfigContainer from '@totem/components/settings/sections/nozomi/eventConfiguration/nozomiEventConfigContainer';

const NozomiEventConfigSection = () => {
  return (
    <NozomiEventConfigContainer>
      <EventConfigurationLayout />
    </NozomiEventConfigContainer>
  );
};

export default NozomiEventConfigSection;
